module.exports = __webpack_public_path__ + "img/23-YXO.ca98e88.jpg";